module.exports = "/assets/data/e8afff063860186c8de21c40f9cdca2f-NG10.data.json";